<template>
    <div>
        <my-search timeScreen :searchParams="searchParams" :selectArr="selectArr" @searchEvent="searchEvent" />
        <myTable :loading="loading" :tableData="tableData" :tableHeader="tableHeader">
            <template v-slot:table_after>
                <el-table-column label="有效期" align="center" width="300">
                    <template slot-scope="{ row }">
                        <span>{{`${row.startTime} 至 ${row.endTime}`}}</span>
                    </template>
                </el-table-column>
            </template>
        </myTable>
        <my-pagination :childMsg="pageParams" @callFather="callFather" />
    </div>
</template>

<script>
import { selectCardPage } from "@/network/content/enterprise.js";
import mixins from "@/mixins/common";
export default {
    name: "resources",
    mixins: [mixins],
    data() {
        return {
            tableHeader: Object.freeze([
                {
                    name: "编码",
                    prop: "code",
                },
                {
                    name: "公司",
                    prop: "unitName",
                },
                {
                    name: "绑定时间",
                    prop: "createTime",
                },
                {
                    name: "绑定状态",
                    prop: "bindingStatus",
                    formatData(val) {
                        return ["未绑定", "已绑定"][
                            Number(val)   //0 未绑定 1已经绑定，2作废此卡  status为3 
                        ];
                    },
                },
                {
                    name: "卡片状态",
                    prop: "status",
                    formatData(val) {
                        return { "0": "正常", "1": "激活", "3": "废除" }[
                            Number(val)   //0 正常 3废除 
                        ];
                    },
                },
                {
                    name: "邀请推荐频道",
                    prop: "channelId",
                },
                {
                    name: "受邀人",
                    prop: "invivationUserName",
                    formatData(val) {
                        if (!val) {
                            return "--"
                        }
                        return val
                    },
                }
            ]),
            selectArr: Object.freeze([
                {
                    defaultText: "请选择卡片状态",
                    name: "status",
                    defaultOptions: [{
                        label: "正常",
                        value: 0
                    },
                    {
                        label: "激活",
                        value: 1
                    },
                    {
                        label: "废除",
                        value: 3
                    }],
                },
                {
                    defaultText: "请选择邀请卡类型",
                    name: "type",
                    defaultOptions: [
                        {
                            label: "基础邀请卡",
                            value: 1
                        },
                        {
                            label: "隐藏频道",
                            value: 2
                        }],
                },
            ]),
            searchParams: {
                timeOptions: [],
            },
        };
    },
    methods: {
        getInitData(currentPage = this.pageParams.currentPage) {
            let { timeOptions, type, status } = this.searchParams;
            let params = {
                type, status,
                startTime: timeOptions ? timeOptions[0] : "",
                endTime: timeOptions ? timeOptions[1] : "",
                current: currentPage,
                size: this.pageParams.pageSize,
            };
            selectCardPage(params).then((e) => {
                this.loading = true;
                let { code, data } = e.data;
                if (code == 200) {
                    this.loading = false;
                    this.tableData = data.records;
                    this.pageParams.total = data.total;
                }
            });
        },
        // 搜索
        searchEvent() {
            this.getInitData(1);
        },
    },
};
</script>

<style lang="scss" scoped>
.search {
    // height: 100px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.addBtn {
    margin: 0 0 10px 20px;
}
.el-select {
    width: 100%;
}

::v-deep .el-select {
    width: 100%;
    .el-select__tags {
        white-space: nowrap;
        overflow: hidden;
        flex-wrap: nowrap;
        .el-select__tags-text {
            display: inline-block;
            // max-width: var(--tagsWidth);
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
    }
}
</style>